import { ReactNode } from 'react'
import { Payload } from 'recharts/types/component/DefaultTooltipContent'

export enum ChartType {
  LINE = 'line',
  BAR = 'bar',
  PIE = 'pie',
}
export type TimeScale = 'All' | '1d' | '1w' | '1m' | '3m' | '6m' | '1y' | '3y'

export type LabelFormatter = (label: string | number | Date, payload: Payload<number, string>[]) => ReactNode

export type TooltipProps = Readonly<{
  active?: boolean
  allLabels?: string[]
  chartType?: ChartType
  entryPayloadFilter?: (entry: Payload<number, string>) => (Payload<number, string> & { extraInfo?: ReactNode }) | null
  formatter?: (value: number, index: number) => string | number
  label?: string | number
  labelColors?: Record<string, string>
  labelFormatter?: LabelFormatter
  payload?: Payload<number, string>[]
  visibility?: number[]
}>

export type BarPieChartData = { name: string; value: number }[]

export type LineChartDataByDate = { [date: string]: Record<string, number> }

export type LineChartData = Record<string, number | null>[]

export type TruthyYieldDatum = { value: number; timestamp: string }

export type TruthyYieldData = TruthyYieldDatum[]

export type ChartMargin = {
  top: number
  right: number
  left: number
  bottom: number
}
